export default "__VITE_ASSET__BFCAolDi__"